const valoresBooleanosAtivos = [true, 1, "1", "true", "ativo", "ativa"];

const integracaoEstaAtiva = (valor) =>
  valoresBooleanosAtivos.includes(
    typeof valor === "string" ? valor.trim().toLowerCase() : valor
  );

const dadosBanco = (conta = {}) => {
  const codigoBanco = String(
    conta?.banco?.code ??
      conta?.banco ??
      conta?.codigo_banco ??
      conta?.banco_zoop?.code ??
      ""
  ).replace(/^0+/, "");

  const nomesBanco = [
    conta?.nome,
    conta?.banco?.name,
    conta?.banco_zoop?.name,
    conta?.descricao,
  ]
    .filter(Boolean)
    .join(" ")
    .toUpperCase();

  return { codigoBanco, nomesBanco };
};

export const isSicoobApiAtiva = (conta = {}) => {
  const { codigoBanco, nomesBanco } = dadosBanco(conta);

  const contaEhSicoob = codigoBanco === "756" || nomesBanco.includes("SICOOB");

  return contaEhSicoob && integracaoEstaAtiva(conta?.integracao_api);
};

export const isSicrediApiAtiva = (conta = {}) => {
  const { codigoBanco, nomesBanco } = dadosBanco(conta);
  const contaEhSicredi =
    codigoBanco === "748" || nomesBanco.includes("SICREDI");

  return contaEhSicredi && integracaoEstaAtiva(conta?.integracao_api);
};

export const isBoletoApiAtiva = (conta = {}) =>
  isSicoobApiAtiva(conta) || isSicrediApiAtiva(conta);
